import { useState } from "react"

export const useGlobalStates = () => {
    
    //para el formulario
    const [showForm, setShowForm ] = useState(false)
    const [formOpeningMode, setFormOpeningMode] = useState('EDITABLE')


    return Object.freeze({
        showForm, setShowForm,
        formOpeningMode, setFormOpeningMode
    })
}